import React from 'react';
import config from '../../config/tableConfig';

const DiscountFeed = ({ discount, onToggle, onDelete }) => {
  if (!discount) return null;

  const {
    _id,
    title,
    type,
    brandList,
    productList,
    value,
    endDate,
    enabled,
    createdAt,
    updatedAt
  } = discount;

  const formatDate = (d) => {
    if (!d) return '—';
    try {
      return new Date(d).toLocaleDateString(config.locales.region);
    } catch (e) {
      return String(d);
    }
  };

  return (
    <div className="card mb-2" key={_id}>
      <div className="card-body d-flex justify-content-between align-items-start">
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="d-flex align-items-center mb-1">
            <h5
              className="mb-0 mr-2"
              style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
            >
              {title || '(sin título)'}
            </h5>

            <div
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '2px 8px',
                borderRadius: 12,
                border: '1px solid rgba(0,0,0,0.08)',
                background: type === 'BRAND' ? '#f0fff4' : '#f3f7ff',
                color: '#222',
                fontSize: 12,
                fontWeight: 600,
                marginRight: 8
              }}
              title={`Tipo: ${type}`}
            >
              {type}
            </div>

            <span className={`badge ${enabled ? 'badge-success' : 'badge-secondary'}`}>
              {enabled ? 'Habilitado' : 'Inhabilitado'}
            </span>
          </div>

          <div className="text-muted mb-1" style={{ fontSize: 13 }}>
            <strong>Valor:</strong> {value != null ? `${value}%` : '—'}
            {'  '}|{'  '}
            <strong>Vence:</strong> {formatDate(endDate)}
            {'  '}|{'  '}
            <strong>Actualizado:</strong> {formatDate(updatedAt || createdAt)}
          </div>

          <div style={{ fontSize: 14 }}>
            {Array.isArray(brandList) && brandList.length > 0 && (
              <div>
                <strong>Marcas:</strong> {brandList.join(', ')}
              </div>
            )}

            {Array.isArray(productList) && productList.length > 0 && (
              <div>
                <strong>Productos:</strong> {productList.join(', ')}
              </div>
            )}
          </div>
        </div>

        <div className="ml-3 d-flex flex-column align-items-end">
          <div className="mb-2">
            <div className="custom-control custom-switch">
              <input
                type="checkbox"
                className="custom-control-input"
                id={`discount-switch-${_id}`}
                checked={!!enabled}
                onChange={() => onToggle && onToggle(_id)}
                aria-label={enabled ? 'Deshabilitar descuento' : 'Habilitar descuento'}
              />
              <label
                className="custom-control-label"
                htmlFor={`discount-switch-${_id}`}
                style={{ cursor: 'pointer' }}
              >
                {enabled ? 'Habilitado' : 'Inhabilitado'}
              </label>
            </div>
          </div>

          <div>
            <button
              type="button"
              className="btn btn-sm btn-danger"
              onClick={() => onDelete && onDelete(_id)}
            >
              Eliminar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountFeed;
